import { Badge } from '@src/design-system/badge';
import { CloseCircle } from 'iconsax-react';

import type { TLabel } from '@shared/types/label';
import { useState } from 'react';

interface LabelBadgeProps {
  label: TLabel;
  editable: boolean;
  onRemove: () => void;
  badgeClassName?: string;
  removeIconClassName?: string;
}
export const LabelBadge: React.FC<LabelBadgeProps> = ({
  label,
  editable,
  onRemove,
  badgeClassName,
  removeIconClassName,
}) => {
  const [showRemoveIconId, setShowRemoveIconId] = useState<number | null>(null);
  let closeTimeout: ReturnType<typeof setTimeout>;

  return (
    <div
      className='relative inline-block'
      onMouseEnter={() => {
        if (closeTimeout) clearTimeout(closeTimeout);
        setShowRemoveIconId(label.id);
      }}
      onMouseLeave={() => {
        closeTimeout = setTimeout(() => setShowRemoveIconId(null), 100);
      }}
    >
      <Badge
        variant='customizable'
        style={{ backgroundColor: label.hexa_color }}
        className={`rounded-xl box-border text-[var(--mainText)] font-medium  cursor-pointer hover:opacity-70 py-1.5 px-2.5 ${badgeClassName || ''}`}
      >
        {label.name}
      </Badge>
      {showRemoveIconId && editable && (
        <CloseCircle
          variant='Bold'
          size={16}
          className={`absolute -top-1 -right-1 text-gray-700 bg-white rounded-full cursor-pointer p-[1px] ${removeIconClassName || ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        />
      )}
    </div>
  );
};
